import { ISession } from '../../resource/session/session.types';
import { IApiRequestConfig } from '../api.types';

export const fetchSessionTranscriptSummaryApi = (sessionId: ISession['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'fetchSessionTranscriptSummary',
  uri: 'json',
  action: `sessions/${sessionId}/transcript/summary`,
  method: 'get',
  v2: true,
});
